import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { TextMultiline, TextMultilineProps } from './TextMultiline';

export interface StandaloneTextMultilineProps extends StandaloneComponentProps {
  markup: TextMultilineProps['markup'];
  options?: Omit<TextMultilineProps, 'markup'>;
}

export const StandaloneTextMultiline: StandaloneComponent<StandaloneTextMultilineProps> = ({
  markup,
  options,
  ...props
}) => {
  return <TextMultiline {...{ markup }} {...options} {...props} />;
};

export default StandaloneTextMultiline;
